module.exports = __webpack_public_path__ + "static/img/risk_search_icon.334dc63b.png";